module.exports = __webpack_public_path__ + "static/media/line-interpolation.7f4141ef.png";